module.exports = __webpack_public_path__ + "img/CM-SL-CA-BMW-Established.357ce793.jpeg";